import {useState} from "react";
import {GameInfo, Inning, Player, Season} from "@/types/types";
import SaveNewGameFlow from "@/pages/SaveNewGameFlow/SaveNewGameFlow";
import dayjs from "dayjs";
import {useCreateScorekeepingGameMutation} from "@/store/scorekeepingGame/scorekeepingGameApiSlice";
import AsyncButton from "@/components/common/AsyncButton";

function SaveNewGamePage() {

    const [season, setSeason] = useState({} as Season);
    const [gameInfo, setGameInfo] = useState({date : dayjs()} as GameInfo);
    const [lineup, setLineup] = useState([] as Player[]);
    const [gameSequence, setGameSequence] = useState([{inning : 1, atBats : []}] as Inning[]);
    const [showConfirmButton, setShowConfirmButton] = useState(false);

    const [createScorekeepingGameTrigger, createScorekeepingGameQuery] = useCreateScorekeepingGameMutation();

    const confirmGameInfo = () => {
        setShowConfirmButton(true);
    }

    const saveGame = async () => {
        // clean up and validate....
        gameInfo.runsFor = gameSequence.flatMap(inning => inning.atBats).map(atBat => atBat.runs.length).reduce((partialSum, a) => partialSum + a, 0);

        if (gameSequence[gameSequence.length-1].atBats.length < 1 && gameSequence[gameSequence.length-1].opponentRuns === undefined) {
            gameSequence.pop();
        }

        if (gameInfo.runsAgainst === undefined || gameInfo.runsAgainst === null) {
            const opponentRuns = gameSequence.map(inning => inning.opponentRuns ? inning.opponentRuns : 0).reduce((partialSum, a) => partialSum + a, 0);
            gameInfo.runsAgainst = opponentRuns;
            setGameInfo(gameInfo);
        }

        const createScorekeepingGameDTO = {
            season : season,
            gameInfo : {...gameInfo, date : gameInfo.date.format("YYYY-MM-DDTHH:mm")},
            innings : gameSequence
        }

        console.log(createScorekeepingGameDTO);

        await createScorekeepingGameTrigger(createScorekeepingGameDTO);

        setGameInfo(gameInfo);
        setGameSequence(gameSequence);
        setShowConfirmButton(false);
    }

    return (
        <div className="content">
            <SaveNewGameFlow season={season}
                             gameInfo={gameInfo}
                             lineup={lineup}
                             gameSequence={gameSequence}
                             setSeason={setSeason}
                             setGameInfo={setGameInfo}
                             setLineup={setLineup}
                             setGameSequence={setGameSequence}
                             confirmGameInfo={confirmGameInfo}
            />

            {showConfirmButton && (
                <AsyncButton onClick={() => saveGame()} isLoading={createScorekeepingGameQuery.isLoading}> Confirm Save Game </AsyncButton>
            )}
        </div>
    )
}

export default SaveNewGamePage;